module.exports = __webpack_public_path__ + "assets/621f527855c863bd3551d555f3d17cea.png";